import { ConnectionSystem } from 'generated/graphql';

export default () => [
    {
        systemName: ConnectionSystem.Zendesk,
        serviceLogo: '/assets/images/connections/zendesk-logo.svg',
        enabled: true,
    },
    {
        systemName: ConnectionSystem.Gorgias,
        serviceLogo: '/assets/images/connections/gorgias-logo.svg',
        enabled: true,
    },
];
